/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

//////////////////////////////////////////////////////////
/////////////////////// SLIDERS //////////////////////////
//////////////////////////////////////////////////////////

let sliderControls = document.querySelectorAll('.slider__control');
for(let i = 0; i < sliderControls.length; i++) sliderControls[i].addEventListener('click', function(e) {
    e.preventDefault();
    let wrapper = this.closest('.slider__wrapper');
    let gap = 0;
    let slideNum = 1;
    if(wrapper.hasAttribute('data-gap')) gap = Number(wrapper.getAttribute('data-gap'));
    if(wrapper.hasAttribute('data-slide')) slideNum = Number(wrapper.getAttribute('data-slide'));
    let slider = wrapper.querySelector('.sp_slider');
    let firstSlide = slider.querySelector('.slide');

    if(!firstSlide) firstSlide = slider.querySelector('*');

    let slideWidth = firstSlide.offsetWidth;
    let currentScroll = slider.scrollLeft;
    let maxScroll = slider.scrollWidth - slider.clientWidth;

    let maxPage = Math.round(maxScroll / slideWidth);
    let currentPage = Math.round(currentScroll / slideWidth);

    if(this.classList.contains('slider__control--next')) {
        if(currentPage < maxPage) currentPage += slideNum;
        if(currentPage > maxPage) currentPage = maxPage;

        slider.scrollLeft = currentPage * slideWidth + gap;
    } else if(this.classList.contains('slider__control--prev')) {
        if(currentScroll > 0) currentPage -= slideNum;
        if(currentPage < 0) currentPage = 0;

        slider.scrollLeft = currentPage * slideWidth - gap;
    }
console.log(currentPage, maxPage);
    if(currentPage == maxPage) wrapper.classList.add('slider__wrapper--end');
    else wrapper.classList.remove('slider__wrapper--end');
    if(currentPage == 0) wrapper.classList.add('slider__wrapper--start');
    else wrapper.classList.remove('slider__wrapper--start');
});

function checkSlider(slider) {
    let wrapper = slider.closest('.slider__wrapper');
    if(!wrapper) return;
    let currentScroll = Math.ceil(slider.scrollLeft);
    let maxScroll = slider.scrollWidth - slider.clientWidth;

    if(maxScroll == currentScroll) wrapper.classList.add('slider__wrapper--end');
    else wrapper.classList.remove('slider__wrapper--end');

    if(currentScroll == 0) wrapper.classList.add('slider__wrapper--start');
    else wrapper.classList.remove('slider__wrapper--start');
}

let sliders = document.querySelectorAll('.sp_slider');
let sliderThrottle = false;
for(let i = 0; i < sliders.length; i++) {
    let slider = sliders[i];
    slider.classList.add('scrolling-back');
    slider.scrollLeft = 0;
    setTimeout(() => slider.classList.remove('scrolling-back'), 10);
    checkSlider(slider);
    slider.addEventListener('scroll', function() {
        if(sliderThrottle !== false) clearTimeout(sliderThrottle);
        sliderThrottle = setTimeout(() => checkSlider(this), 305);
    });

    if(slider.hasAttribute('data-autoslide')) {
        let autoslide = Number(slider.getAttribute('data-autoslide'));
        if(isNaN(autoslide)) continue;
        
        runSlider(slider, autoslide);
    }
}

function runSlider(slider, autoslide) {
    setInterval(function() {
        let slideWidth = slider.offsetWidth;
        let currentScroll = slider.scrollLeft;
        let maxScroll = slider.scrollWidth - slider.clientWidth;
        let gap = 0;
        let wrapper = slider.closest('.slider__wrapper');
        if(wrapper && wrapper.hasAttribute('data-gap')) gap = Number(wrapper.getAttribute('data-gap'));
    
        let maxPage = Math.round(maxScroll / slideWidth);
        let currentPage = Math.round(currentScroll / slideWidth);
    
        currentPage++;
    
        slider.scrollLeft = currentPage * slideWidth + gap;
    
        if(currentPage >= maxPage) {
            setTimeout(function() {
                slider.classList.add('scrolling-back');
                setTimeout(() => slider.scrollLeft = 0, 50);
                setTimeout(() => slider.classList.remove('scrolling-back'), 50);
            }, 1000);
        }
    }, autoslide * 1000);
}

if(window.innerWidth <= 900) {
    let carouselSliders = document.querySelectorAll('.products-carousel__slider');
    for(let i = 0; i < carouselSliders.length; i++) {
        new SimpleBar(carouselSliders[i], { autoHide: false });
    }
}

//////////////////////////////////////////////////////////
//////////////////// END SLIDERS /////////////////////////
//////////////////////////////////////////////////////////